
var ModalWarningAccountingCards = {
    view: function (ctrl, args) {
        return [m("div.dm-overlay[id='']", [
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal[style='border: 0; width: 100%; max-width: 54em; ']", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[style='padding-right: 20px;'][id='']", "Предупреждение"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: ModalContainerWarningAccountingСards.close()
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 15px; width: 100%; height: auto; display: block; position: relative;']", [
                                    m("div[id='contentWarringAccCard'][style='border: 0; top:0px; left:0px; width: 100%;text-align: center;']"),
                                    m("br"),
                                    m(".row[style='text-align: center;']", [
                                        m("button.btn.btn-warning.btn-lg", {
                                            id: "",
                                            onclick: function () {
                                                ModalContainerWarningAccountingСards.close();
                                            }
                                        }, "Ок")
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        ])];
    }
};

export var ModalContainerWarningAccountingСards = {
    container: null,
    init: function (idDiv) {
        ModalContainerWarningAccountingСards.container = document.querySelector('#'+idDiv);
        if (!ModalContainerWarningAccountingСards.container) {
            ModalContainerWarningAccountingСards.container = document.createElement('div');
            ModalContainerWarningAccountingСards.container.id = idDiv;
            ModalContainerWarningAccountingСards.container.hidden = true;
            document.body.appendChild(ModalContainerWarningAccountingСards.container);

            m.mount(ModalContainerWarningAccountingСards.container, m.component(ModalWarningAccountingCards, {title: ""}));
        }
    },
    open: function (content = null, idDiv=null) {
        if(ModalContainerWarningAccountingСards.container === null)
            ModalContainerWarningAccountingСards.container = document.querySelector('#'+idDiv);
        if(ModalContainerWarningAccountingСards.container /*&& srcdoc != null*/) {
            document.getElementById(idDiv).innerText = content;
            //document.getElementById("srcIframe").srcdoc = srcdoc;
            ModalContainerWarningAccountingСards.container.hidden = false;
            m.redraw.strategy("diff");
        }
    },
    close: function () {
        ModalContainerWarningAccountingСards.container.hidden = true;
    }
};
